import { SupplyOrderProps } from "@/types"

export const checkIfCheckedSupplierOrdersIsValid = (
  values: Record<string, SupplyOrderProps>,
) => {
  const arrayValues = Object.values(values)

  if (arrayValues.length === 0) return true

  const firstSupplierUuid = arrayValues?.[0]?.supplier?.uuid

  return arrayValues.every(
    (supplierOrder) => supplierOrder?.supplier?.uuid === firstSupplierUuid,
  )
}